<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.jpg">
    <h1>Nye og spennende sider kommer snart...</h1>

    <p>
      i mellomtiden kan du kontakte oss på 
    </p>

    <a href="mailto:info@tretek.no">info@tretek.no</a>
    <a href="mailto:service@tretek.no">service@tretek.no </a>
    <a href="tel:+4770146100">tel: + 47 701 46 100</a>

    <!-- <a href="/salgsbetingelser.pdf">salgsbetingelser.pdf</a> -->
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  margin-top: 60px;
  display: flex;
  flex-flow: column;

  font-size: 20px;

  h1 {
    font-weight: 500;
  }

  p {
    font-size: 26px;
  }

  a {
    color: black;
    margin-bottom: 10px;
  }

  img {
    width: 250px;
    margin: 0 auto;
  }
}
</style>
